import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC, PropsWithChildren } from 'react';

import { ImageTheme } from '@gem/call/Removable/components/ImageTheme/ImageTheme';

import styles from './RoomCallPopupContent.styles.m.css';

interface IRoomCallPopupContentProps {
  className?: string;
  lightImageName: string;
  darkImageName: string;
  applicationTheme: 'light' | 'dark';
}

export const RoomCallPopupContent: FC<PropsWithChildren<IRoomCallPopupContentProps>> = observer(
  (props) => {
    return (
      <div className={classNames(styles.container, props.className)}>
        <div className={styles.header}>
          <ImageTheme
            className={styles.logo}
            lightImageName={props.lightImageName}
            darkImageName={props.darkImageName}
            applicationTheme={props.applicationTheme}
          />
        </div>
        {props.children}
      </div>
    );
  }
);
